/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Preview_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Event preview" |
*
* @param {Event_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_preview_aria_label = /** @type {((inputs?: Event_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsvorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр мероприятия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट का पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prévia do evento")
	return /** @type {LocalizedString} */ ("Event preview")
});